<template>
  <div class="all_form_block" data-name="contacts">
    <div class="block">
      <div class="name_tools" id="contacts">{{ $store.getters.cv_t('cv_contact') }}</div>
      <div class="all_form">
        <div class="inp_info">
          <div class="div_relative active">
            <vue-tel-input
              :defaultCountry="$store.getters.locale"
              v-model.trim="$store.state.cv.phone"
              :inputClasses="validPhone ? '' : 'invalid'"
              :preferredCountries="['us', 'am', 'ru']"
              @onInput="validatePhone"
              :placeholder="$store.getters.cv_t('phone')"
              :validCharactersOnly="true"
            ></vue-tel-input>
          </div>
          <div class="div_relative">
            <span v-on:click="$parent.correctLabel($event)">{{ $store.getters.cv_t('email') }}</span>
            <input
              name="email"
              v-validate="'required|email'"
              v-model.trim.layz="$store.state.cv.email"
              required
              type="text"
              :class="errors.first('email') ? 'invalid' : ''"
              v-on:input="$parent.correctLabel($event)"
              v-on:keyup.tab="$parent.correctLabel($event)"
              v-on:click="$parent.correctLabel($event)"
            >
          </div>
          <div class="div_relative">
            <google-map
              :name="'address'"
              :lat="$store.state.cv.address.lat"
              :lng="$store.state.cv.address.lng"
              v-model="$store.state.cv.address.address"
              :callback="mapResult"
            ></google-map>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import VueTelInput from "vue-tel-input";
  import "vue-tel-input/dist/vue-tel-input.css";
  import GoogleMap from "./GoogleMap";

  export default {
    data() {
      return {
        validPhone: true,
        validEmail:false
      };
    },
    components: {
      VueTelInput,
      GoogleMap
    },
    mounted() {
      document.querySelectorAll(".vue-tel-input .dropdown-item").forEach(item => {
        item.addEventListener("click", function () {
          let code = item.querySelector("span").innerText;
          document
            .querySelector(".vue-tel-input input")
            .setAttribute("placeholder", code);
        });
      });
    },
    watch: {
      '$store.state.cv.email'(val, old) {
        if(this.ValidateEmail(val)){
          this.validEmail = true;
          this.$store.dispatch('sendMailchimpApi')
        }else{
          this.validEmail = false;
        }
      },
      '$store.state.cv.phone'(newVal){
        if(this.validPhone && this.validEmail){
          this.$store.dispatch('sendMailchimpApi')
        }
      },
      '$store.state.cv.address.address'(newVal){
        this.$store.dispatch('sendMailchimpApi')
      }
    },
    methods: {
      mapResult(data) {
        this.$store.state.cv.address = data
      },
      validatePhone({number, isValid, country}) {
        this.validPhone = isValid;
      },
      ValidateEmail(inputText) {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (inputText.match(mailformat)) {
          return true;
        }
        return false;
      }
    }
  }
  ;
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/cv/tools-components/Contacts.vue